import { graphql } from 'gatsby'
import React from 'react'

import ContactPage from '../containers/ContactPage'

const Contact = ({ data }) => {
  return <ContactPage {...data.portal} />
}

export default Contact

export const query = graphql`
  query ContactQuery ($firebaseId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PartialPortalData
      ...ContactData
    }
  }
`
